import React, {ReactNode, ReactNodeArray, CSSProperties, useState, useEffect} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import PrivateCompanyData from '../../../Models/Content/PrivateCompanyBlockData'
import Header from './Header'

export default class PrivateCompanyBlock extends EpiComponent<PrivateCompanyData>
{
    constructor(props) {
        super(props);  
    }

    public render() : ReactNode | ReactNodeArray | null
    {
        return (
            <Header context={this.getContext()} iContent={this.props.data} />
        );
    }
}